import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestCallService } from '../services/rest-call.service';
import { MessageManagementService } from '../services/message-management.service';
import { NbToastrService } from '@nebular/theme';
import { ISite, ISiteProperty } from '../data/ISite';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends RestCallService {

  constructor(
    public httpClient: HttpClient,
    public toastr: NbToastrService,
    public messageService: MessageManagementService
  ) {
    super(httpClient, toastr, messageService);
  }

  public getClientByCode(code: string) {
    return this.get('Client/GetClientByCode/' + code);
  }
}
